import { RouteConfig } from "vue-router";

import Index from "../views/index/Index.vue";
import InscriptionFlowInfo from "../views/inscription-flow-form/InscriptionFlowInfo.vue";
import InscriptionFlowRegister from "../views/inscription-flow-form/InscriptionFlowRegister.vue";
import InscriptionFlowEnd from "../views/inscription-flow-form/InscriptionFlowEnd.vue";
import InscriptionFlowRedirectEnd from "../views/inscription-flow-form/InscriptionFlowRedirectEnd.vue";
import FormAccountDetection from "../views/inscription-flow-form/FormAccountDetection.vue";
import FormCpsRegister from "../views/cps-cpx/FormCpsRegister.vue";
import { InscriptionFlowFormType } from "../models/enums/InscriptionFlowFormType";
import AccountAssociation from "../views/association/AccountAssociation.vue";

declare const window: {
  inscriptionFlowSettings: any;
};

// Routes pré-définies pour afficher les différentes vues
export const routes = [
  {
    path: "/",
    component: Index,
    name: "index"
  },
  {
    path: "/info",
    component: InscriptionFlowInfo,
    name: "inscription-flow-info"
  },
  {
    path: "/email",
    component: FormAccountDetection,
    name: "form-account-detection-by-email",
    props: route => ({
      ...route.params,
      name: window["inscriptionFlowSettings"].Name, // Vient du controller
      linking: route.query.linking === "true"
    })
  },
  {
    path: "/nationalId",
    component: FormAccountDetection,
    name: "form-account-detection-by-national-id",
    props: route => ({
      ...route.params,
      name: window["inscriptionFlowSettings"].Name, // Vient du controller
      linking: route.query.linking === "true"
    })
  },
  {
    path: "/register",
    component: InscriptionFlowRegister,
    name: "inscription-flow-register",
    props: route => ({
      ...route.params,
      name: window["inscriptionFlowSettings"].Name, // Vient du controller
      idFormType: InscriptionFlowFormType.NoAccount
    })
  },
  {
    path: "/registerCard",
    component: FormCpsRegister,
    name: "form-cps-register",
    props: route => ({
      ...route.params,
      name: window["inscriptionFlowSettings"].Name // Vient du controller
    })
  },
  {
    path: "/end",
    component: InscriptionFlowEnd,
    name: "inscription-flow-end",
    props: route => ({
      ...route.query,
      name: window["inscriptionFlowSettings"].Name // Vient du controller
    })
  },
  {
    path: "/redirect",
    component: InscriptionFlowRedirectEnd,
    name: "inscription-flow-redirect-end",
    props: route => ({
      ...route.params,
      name: window["inscriptionFlowSettings"].Name // Vient du controller
    })
  },
  {
    // Association page
    path: "/association",
    component: AccountAssociation,
    name: "association",
    props: route => ({
      ...route.params,
      flowName: window["inscriptionFlowSettings"].Name // Vient du controller
    })
  }
] as RouteConfig[];
